export const CASE_CONFIG = {
  brandName: "LexiPro",
  productName: "LitiGate Alpha",
  firmName: "LitiGate Forensic",
  logoText: "LG",
  systemVersion: "v4.9.0-commercial",
  jurisdiction: "State of Columbia (MI)",
  statuteHeader: "MCL - State of Columbia Compiled Laws",
  complianceLevel: "Architecture: SOC2-Aligned / HIPAA-Ready",
  googleDriveClientId: "YOUR_CLIENT_ID", // Typically provided by user or handled by proxy
  defaultSearchQuery: "Assault Care",
  legalDisclaimer: "Forensic Data Synthesis only. Not legal advice.",
  DEMO_MATTER_ID: "lexis-matter-01",
  DEMO_WORKSPACE_ID: "lexis-workspace-01",
  ENABLE_FORENSIC_REDLINE: true,
  ENABLE_TELEPORTATION: true,
  uiStrings: {
    dashboardTitle: "Assault Care Strategy Hub",
    matrixTitle: "Discovery Evidence Port",
    vaultTitle: "Assault Care Privileged Vault",
    auditTitle: "Forensic Master Synthesis",
    waitMsg: "Executing Forensic Deep-Scan...",
    integrityGuardMsg: "INTEGRITY GUARD: All findings require forensic verification before court production.",
    footerCrt: "Produced by LexiPro Enterprise SaaS."
  }
};
